<template>
  <div>
    <div class="q-mb-lg">
      <ReferrerReport />
    </div>
    <div class="q-mb-lg">
      <SalesReport />
    </div>
    <StatusReport />
  </div>
</template>

<script>
import ReferrerReport from '@client/components/reports/referrer-report/index';
import SalesReport from '@client/components/reports/sales-report/index';
import StatusReport from '@client/components/reports/status-report/index';

export default {
  components: {
    ReferrerReport,
    SalesReport,
    StatusReport
  },
  name: 'Reports',
  metaInfo: {
    title: 'AutoBook Pro - Report'
  },
  data() {
    return {
      tab: 'mails'
    };
  }
};
</script>
<style lang="scss"></style>
